import { useRef, useState } from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { cloudUploadOutline, trashOutline } from "ionicons/icons";

// An uploaded logo/image once it is in: just the image with the app's drop
// shadow behind it (no box, no border), the file name when known, and a
// Remove button.
export function UploadedImage({ src, alt = "logo", name, onRemove, height = 72 }) {
  return (
    <div className="uploaded-image" style={{ display: "flex", alignItems: "center", gap: 14, padding: "8px 0" }}>
      <img src={src} alt={alt} style={{ maxHeight: height, maxWidth: "55%", objectFit: "contain", filter: "drop-shadow(0 4px 24px rgba(0,0,0,0.18))" }} />
      {name && <span style={{ flex: 1, minWidth: 0, fontSize: "0.78rem", color: "var(--ion-color-medium)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>}
      {/* The admin's round icon-only trash button */}
      <IonButton fill="clear" shape="round" color="danger" aria-label="Remove" title="Remove" onClick={onRemove} style={{ marginLeft: "auto", flexShrink: 0 }}>
        <IonIcon icon={trashOutline} slot="icon-only" />
      </IonButton>
    </div>
  );
}

// The image upload area used by every /app modal: a dashed drop zone on the
// page background with a cloud icon, "Drag & Drop Files", "or" and an
// outlined BROWSE FILES button. Dropping a file or picking one through the
// button calls onFile(file).
export default function UploadDropzone({ onFile, accept = "image/*", title = "Drag & Drop Files", buttonLabel = "BROWSE FILES", minHeight = 190, style }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);

  const take = (files) => {
    const file = files && files[0];
    if (file) onFile?.(file);
  };

  return (
    <div
      className={`upload-dropzone${over ? " is-over" : ""}`}
      onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); if (!over) setOver(true); }}
      onDragLeave={(e) => { e.preventDefault(); setOver(false); }}
      onDrop={(e) => { e.preventDefault(); e.stopPropagation(); setOver(false); take(e.dataTransfer?.files); }}
      style={{
        minHeight, width: "100%", boxSizing: "border-box",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 6,
        padding: "22px 16px", borderRadius: 4,
        border: `2px dashed ${over ? "var(--ion-color-primary)" : "var(--ion-color-medium)"}`,
        background: "var(--ion-background-color)",
        color: "var(--ion-color-medium)", textAlign: "center",
        transition: "border-color 0.15s ease",
        ...style,
      }}
    >
      <IonIcon icon={cloudUploadOutline} style={{ fontSize: 40, color: "var(--ion-color-medium)" }} aria-hidden="true" />
      <div style={{ fontSize: "1rem", fontWeight: 700, color: "var(--ion-color-medium)", lineHeight: 1.2 }}>{title}</div>
      <div style={{ fontSize: "0.85rem", color: "var(--ion-color-medium)", lineHeight: 1 }}>or</div>
      <IonButton
        fill="outline" mode="md"
        onClick={() => inputRef.current?.click()}
        style={{ "--color": "var(--ion-text-color)", "--border-color": "var(--ion-text-color)", "--background-hover": "rgba(127,127,127,0.12)", "--border-width": "2px", "--border-radius": "4px", "--padding-start": "22px", "--padding-end": "22px", fontWeight: 700, letterSpacing: "0.04em", marginTop: 6 }}
      >
        {buttonLabel}
      </IonButton>
      <input
        ref={inputRef} type="file" accept={accept} style={{ display: "none" }}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onFile?.(f); }}
      />
    </div>
  );
}
